import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "FrameworkAgreementIterationDashboardPage" */
	'pages/sales/FrameworkAgreementIteration/FrameworkAgreementIterationDashboardPage'));

export default [{ component, exact: true, path: '/framework_agreement_iterations/:frameworkAgreementIterationId' }];